<template lang="pug">
panel-base(
  :title="title"
  :value="showValue"
  :action-type="actionType"
  no-reset
  v-bind="$attrs"
)
  dv-select.mt-2(
    v-model="inputValue"
    :items="items"
    :height="40"
    v-bind="$attrs"
  )
  //- app-button(
  //-   rounded
  //-   :disabled="isIndicateButtonDisabled"
  //-   @click="indicateTextInput"
  //- ).mt-2 Указать
</template>

<script>
import DvSelect from '@/packages/ui/components/inputs/DvSelect.vue';
import PanelBase from './PanelBase.vue';
import { ROW_ACTION_KEY } from '../constants';
import { isObject } from 'lodash';

export default {
  name: 'PanelSelect',
  components: {
    PanelBase,
    DvSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isSimpleItems() {
      return this.items.some((i) => !isObject(i));
    },
    showValue() {
      const item = this.isSimpleItems
        ? this.items.find((i) => i === this.value)
        : this.items.find(({ id }) => id === this.value);
      return item?.name || item;
    },
    actionType() {
      const { indicate } = ROW_ACTION_KEY;

      return indicate;
    },
  },
  watch: {
  },
  created() {},
  methods: {},
};
</script>
